import { __decorate } from 'tslib';
import { Injector, Compiler, Input, Component, ViewEncapsulation, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function LazyComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c0 = [[["", "whileLoading", ""]]];
const _c1 = ["[whileLoading]"];
let LazyComponent = class LazyComponent {
    constructor(
    // Dependencies
    injector, compiler) {
        this.injector = injector;
        this.compiler = compiler;
        this.keepUpdating = false;
        this.alreadySet = false;
        // State
        this.injectorForComponent = this.injector;
        this.componentType$ = new BehaviorSubject(undefined);
        this.moduleFactory$ = new BehaviorSubject(undefined);
        this.injector$ = new BehaviorSubject(undefined);
        this.loading$ = new BehaviorSubject(true);
        // Load and create component
        this.loaded = 0;
    }
    set providers(value) {
        if (value) {
            this.injectorForComponent = Injector.create({
                parent: this.injector,
                providers: value
            });
        }
        else
            this.injectorForComponent = this.injector;
    }
    ngOnChanges(changes) {
        if (!this.alreadySet || this.keepUpdating) {
            if (changes.componentImporter || changes.moduleImporter) {
                const id = ++this.loaded;
                this.componentType$.next(undefined);
                this.moduleFactory$.next(undefined);
                this.injector$.next(undefined);
                if (this.componentImporter) {
                    this.loading$.next(true);
                    if (this.moduleImporter)
                        Promise.all([this.componentImporter(), this.moduleImporter()]).then(([componentType, module]) => {
                            if (id === this.loaded) {
                                this.componentType$.next(componentType);
                                this.moduleFactory$.next(this.compiler.compileModuleSync(module));
                                this.injector$.next(this.injectorForComponent);
                                this.loading$.next(false);
                            }
                        });
                    else {
                        this.componentImporter().then(componentType => {
                            if (id === this.loaded) {
                                this.componentType$.next(componentType);
                                this.injector$.next(this.injectorForComponent);
                                this.loading$.next(false);
                            }
                        });
                    }
                    this.alreadySet = true;
                }
            }
        }
    }
};
LazyComponent.ɵfac = function LazyComponent_Factory(t) { return new (t || LazyComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Injector), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Compiler)); };
LazyComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LazyComponent, selectors: [["egov-lazy-component"]], inputs: { keepUpdating: "keepUpdating", providers: "providers", componentImporter: "componentImporter", moduleImporter: "moduleImporter" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 6, vars: 12, consts: [[4, "ngIf"], [3, "ngComponentOutlet", "ngComponentOutletNgModuleFactory", "ngComponentOutletInjector"]], template: function LazyComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵtemplate(0, LazyComponent_ng_container_0_Template, 2, 0, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
        ɵngcc0.ɵɵelementContainer(2, 1);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵpipe(4, "async");
        ɵngcc0.ɵɵpipe(5, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 4, ctx.loading$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngComponentOutlet", ɵngcc0.ɵɵpipeBind1(3, 6, ctx.componentType$))("ngComponentOutletNgModuleFactory", ɵngcc0.ɵɵpipeBind1(4, 8, ctx.moduleFactory$))("ngComponentOutletInjector", ɵngcc0.ɵɵpipeBind1(5, 10, ctx.injector$));
    } }, dependencies: [ɵngcc1.NgComponentOutlet, ɵngcc1.NgIf, ɵngcc1.AsyncPipe], encapsulation: 2, changeDetection: 0 });
LazyComponent.ctorParameters = () => [
    { type: Injector },
    { type: Compiler }
];
__decorate([
    Input()
], LazyComponent.prototype, "componentImporter", void 0);
__decorate([
    Input()
], LazyComponent.prototype, "moduleImporter", void 0);
__decorate([
    Input()
], LazyComponent.prototype, "providers", null);
__decorate([
    Input()
], LazyComponent.prototype, "keepUpdating", void 0);

let LazyModule = class LazyModule {
};
LazyModule.ɵfac = function LazyModule_Factory(t) { return new (t || LazyModule)(); };
LazyModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: LazyModule });
LazyModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LazyComponent, [{
        type: Component,
        args: [{
                selector: 'egov-lazy-component',
                template: "<ng-container *ngIf=\"(loading$ | async)\">\n    <ng-content select=\"[whileLoading]\"></ng-content>\n</ng-container>\n<ng-container [ngComponentOutlet]=\"componentType$ | async\" [ngComponentOutletNgModuleFactory]=\"moduleFactory$ | async\"  [ngComponentOutletInjector]=\"injector$ | async\"></ng-container>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc0.Compiler }]; }, { keepUpdating: [{
            type: Input
        }], providers: [{
            type: Input
        }], componentImporter: [{
            type: Input
        }], moduleImporter: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LazyModule, [{
        type: NgModule,
        args: [{
                declarations: [LazyComponent],
                imports: [CommonModule],
                exports: [LazyComponent],
                entryComponents: [LazyComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LazyModule, { declarations: function () { return [LazyComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LazyComponent]; } }); })();

/*
 * Public API Surface of angular-lazy
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LazyModule, LazyComponent as ɵa };

